import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { EecModalService } from '~app/modules/product/services/eec-modal.service';
import { cdnPath } from '~shared/constants/sources.config';

@Component({
  selector: 'app-search-product-energy-efficiency-new',
  templateUrl: './product-energy-efficiency-new.component.html',
  styleUrls: ['./product-energy-efficiency-new.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductEnergyEfficiencyNewComponent implements OnInit {
  @Input() energyEfficiencyImage: string;
  //type is any because we receive dynamic fields
  @Input() energyConfig: any;

  energyLabelSrc: string;
  energyEfficiencyClass: string;
  isGenericLabel = false;

  constructor(private energyEfficiencyModalService: EecModalService) {}

  ngOnInit(): void {
    const defaultAttribute: string =
      this.energyConfig && this.energyConfig?.energy_efficiency_label_config
        ? this.energyConfig?.energy_efficiency_label_config?.defaultAttribute
        : '';

    this.energyEfficiencyClass = this.energyConfig && this.energyConfig[defaultAttribute];

    if (!this.energyConfig?.energy_efficiency_label_config?.values.includes(this.energyEfficiencyClass)) {
      this.isGenericLabel = true;
      this.energyLabelSrc = `${cdnPath()}/images/energy-efficiency-labels/generic.svg`;
    } else {
      this.energyLabelSrc = `${cdnPath()}/images/energy-efficiency-labels/${
        this.energyConfig?.energy_efficiency_label_config?.range?.max
      }-${this.energyConfig?.energy_efficiency_label_config?.range?.min}/${this.energyEfficiencyClass}.svg`;
    }
  }

  onEnergyEfficiencyLabelClick(event): void {
    if (!this.energyEfficiencyImage) {
      return;
    }

    event.stopPropagation();
    event.preventDefault();
    this.energyEfficiencyModalService.openEecDocument(this.energyEfficiencyImage);
  }
}
